import React, { FC } from 'react';
import { AppLink } from 'components/uikit/buttons/AppLink';
import { ButtonColor } from './buttons/Button';
import clsx from 'clsx';
import HintIcon from 'assets/icons/i.svg?react';

import styles from './Field.module.scss';
import { BrightTooltip } from 'components/tooltips/BrightTooltip';
import { TooltipProps } from '@mui/material';

export type FieldLinkProps = {
  title: string | React.ReactNode;
  disabled?: boolean;
  icon?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  testId?: string;
  color?: ButtonColor;
};

export type FieldProps = {
  title: string;
  children?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  childrenWrapperClassName?: string;
  linkProps?: FieldLinkProps;
  hint?: {
    title: string;
    comment?: string;
    placement?: TooltipProps['placement'];
    icon?: React.ReactNode;
  };
  testId?: string;
};

export const Field: FC<FieldProps> = (props) => {
  const { children, className, linkProps, title, titleClassName, testId } =
    props;
  return (
    <div
      className={clsx(className, styles.container)}
      data-test-id={testId}
      data-app-field={title}
    >
      <div className={styles.titleContainer}>
        <div className={styles.titleWithHint}>
          <div className={clsx(styles.title, titleClassName)}>{title}</div>
          {props.hint ? (
            <BrightTooltip
              title={
                <div className={styles.hintContent}>
                  <div className={styles.hintTitle}>{props.hint.title}</div>
                  {props.hint.comment && (
                    <div className={styles.hintComment}>
                      {props.hint.comment}
                    </div>
                  )}
                </div>
              }
              placement={props.hint.placement}
              arrow={false}
            >
              <div className={styles.hint}>
                {props.hint.icon ?? <HintIcon />}
              </div>
            </BrightTooltip>
          ) : null}
        </div>
        {!!linkProps &&
          (typeof linkProps.title === 'string' ? (
            <AppLink
              {...linkProps}
              testId={linkProps.testId ?? 'field-link'}
              color={ButtonColor.Primary}
              className={clsx(styles.fieldLink, linkProps.className)}
            >
              {linkProps.title}
            </AppLink>
          ) : (
            linkProps.title
          ))}
      </div>
      <div className={clsx(styles.field, props.childrenWrapperClassName)}>
        {children}
      </div>
    </div>
  );
};
